import React, { useMemo } from "react";
import { Divider, Tabs } from "antd";

import { WorksList } from "Components/WorksList/WorksList";

const MyTabs = ({
  groups = [],
  selectedWorks = [],
  onChange = () => {},
  disabled = false,
}) => {
  const items = useMemo(() => {
    const works = selectedWorks
      .filter((item) => item.allowedWorkType.groupId !== null)
      .reduce((acc, el) => {
        if (acc[el.allowedWorkType.groupId]) {
          acc[el.allowedWorkType.groupId].push(el);
        } else {
          acc[el.allowedWorkType.groupId] = [el];
        }

        return acc;
      }, {});

    return works;
  }, [selectedWorks, groups]);

  const itemsWithoutGroup = useMemo(() => {
    return selectedWorks.filter(
      (item) => item.allowedWorkType.groupId === null,
    );
  }, [selectedWorks, groups]);

  return (
    <>
      {Object.keys(items).length ? (
        <>
          <Divider>Груповані роботи по об'єкту</Divider>
          {groups.map((group, i) => {
            if (
              Object.keys(items).filter((key) => {
                if (key === group.id) {
                  return items[key];
                }
              }).length
            ) {
              return (
                <Tabs
                  tabBarStyle={{ margin: 0 }}
                  style={{ marginTop: "20px" }}
                  tabPosition="top"
                  type="card"
                  items={Object.keys(items)
                    .filter((key) => {
                      if (key === group.id) {
                        return items[key];
                      }
                    })
                    .map((key) => {
                      return [...items[key]];
                    })
                    .map((item) => {
                      return {
                        closable: false,
                        label: group.title,
                        key: i,
                        children: (
                          <WorksList
                            borderRadius="0 0 10px 10px"
                            borderTop="none"
                            disabled={disabled}
                            items={item}
                            onChange={onChange}
                            groups={groups}
                          />
                        ),
                      };
                    })}
                />
              );
            } else {
              return "";
            }
          })}
        </>
      ) : (
        ""
      )}

      {itemsWithoutGroup.length ? (
        <>
          <Divider>Роботи по об'єкту</Divider>
          <WorksList
            disabled={disabled}
            items={itemsWithoutGroup}
            onChange={onChange}
            groups={groups}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
};
export { MyTabs };
